<template>
  <div
    v-if="allShow"
    :class="[
      'ux-search-option',
      { 'ux-search-option-one': layout.length === 1 ? true : false },
      { 'is-break': isBreak }
    ]"
  >
    <template v-for="(item, index) in layout">
      <div
        :class="['ux-option-item', { 'is-right': item.right }]"
        :style="{ marginRight: item.hasOwnProperty('spacing') ? item.spacing : spacing }"
        v-if="!item.hidden"
      >
        <span class="search-label" v-if="item.label">{{ item.label }}</span>
        <template v-if="item.type === 'select'">
          <!-- <ux-select :style="{width: item.width}" v-model="filter[item.key]" clearable :options="item.options" :filterable="item.filterable" :props="item.props" :disabled="item.disabled" :cascader="item.cascader" :multiple="item.multiple" :placeholder="item.placeholder" @change="change(item.event, $event)"></ux-select> -->
          <ux-select
            :style="{ width: item.width }"
            v-model="filter[item.key]"
            clearable
            v-bind="item"
            @change="change(item.event, $event)"
          ></ux-select>
        </template>
        <template v-else-if="item.type === 'radio'">
          <ux-radio
            :style="{ width: item.width }"
            v-model="filter[item.key]"
            :options="item.options"
            :props="item.props"
            :disabled="item.disabled"
            :spacing="item.spacing"
            @change="change(item.event, $event)"
          ></ux-radio>
        </template>
        <template v-else-if="item.type === 'checkbox'">
          <ux-checkbox
            :style="{ width: item.width }"
            v-model="filter[item.key]"
            :options="item.options"
            :props="item.props"
            :disabled="item.disabled"
            :trueLabel="item.trueLabel"
            :falseLabel="item.falseLabel"
            @change="change(item.event, $event)"
            >{{ item.text }}</ux-checkbox
          >
        </template>
        <template v-else-if="item.type === 'date'">
          <ux-date
            :style="{ width: item.width }"
            v-if="item.key"
            v-model="filter[item.key]"
            :daterange="item.daterange"
            :placeholder="item.placeholder"
            :startPlaceholder="item.startPlaceholder"
            :endPlaceholder="item.endPlaceholder"
            :monthRange="item.monthRange"
            :pickerOptions="item.pickerOptions"
            :time="item.time"
            :top="item.top"
            :right="item.right"
            @change="change(item.event, $event)"
          ></ux-date>
          <ux-date
            :style="{ width: item.width }"
            v-else
            v-model="date"
            :daterange="item.daterange"
            :placeholder="item.placeholder"
            :startPlaceholder="item.startPlaceholder"
            :endPlaceholder="item.endPlaceholder"
            :monthRange="item.monthRange"
            :pickerOptions="item.pickerOptions"
            :time="item.time"
            :top="item.top"
            :right="item.right"
            @change="change(item.event, $event)"
          ></ux-date>
        </template>
        <template v-else-if="item.type === 'input'">
          <div :style="{ width: item.width }" :class="['ux-search ux-utils-flex-align']">
            <ux-input
              v-model="filter[item.key]"
              prefix-icon="ux_icon_search"
              :placeholder="item.placeholder"
              @change="changeInput"
            ></ux-input>
            <ux-button v-if="!item.hideBtn" type="primary" @click="search(filter[item.key])">{{
              item.text || $t('HT.search')
            }}</ux-button>
          </div>
        </template>
        <template v-else-if="item.type === 'button'">
          <ux-button
            :class="{ 'btn-text': item.isText }"
            :type="item.button || 'primary'"
            :icon="item.icon"
            :size="item.size"
            :plain="item.plain"
            :round="item.round"
            :text="item.isText"
            :disabled="item.disabled"
            @click="change(item.event)"
            >{{ item.text }}</ux-button
          >
        </template>
        <template v-else>
          <div :class="['render-item']" :style="{ width: item.width }">
            <rendering v-if="item.render" :render="item.render"></rendering>
          </div>
        </template>
      </div>
      <div class="item-break" v-if="item.break"></div>
    </template>
    <slot></slot>
  </div>
</template>

<script>
import rendering from 'jimi-uxkit/packages/components/modal/render';
import { initProps } from 'jimi-uxkit/packages/uxsdk/initProps';
import locale from 'jimi-uxkit/packages/language';

function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var args = arguments,
      thisArg = this;
    if (immediate && !timeout) {
      func.apply(thisArg, args);
    }
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = undefined;
      if (!immediate) {
        func.apply(thisArg, args);
      }
    }, wait);
  };
}
export default {
  name: 'MySearchOption',
  mixins: [locale],
  components: {
    rendering
  },
  props: {
    layout: initProps(Array), // 配置
    data: initProps(Object), // 需要绑定的数据
    isBreak: initProps(Boolean, false), // 是否换行
    spacing: initProps(String, '40px')
  },

  data() {
    return {
      filter: this.data, // 整个筛选对象
      date: [] // 起始时间
    };
  },

  methods: {
    /**
     * 节流搜索
     */
    debounce: debounce(function (val) {
      this.$emit('search', val);
    }, 300),

    /**
     * 输入框改变
     * @param {String} val 输入的字段
     */
    changeInput(val) {
      this.debounce(val);
    },

    /**
     * 点击搜索按钮
     * @param {String} val 输入的字段
     */
    search(val) {
      this.debounce(val);
    },

    /**
     * 选择器筛选
     * @param {String} event 事件名
     */
    change(event, val) {
      this.$emit(event || 'change', val);
    }
  },

  computed: {
    allShow() {
      let flag = false;
      for (let i = 0; i < this.layout.length; i++) {
        let item = this.layout[i];
        if (!item.hidden) {
          flag = true;
          break;
        }
      }
      return flag;
    }
  }
};
</script>

<style lang="scss" scoped>
.ux-search-option {
  align-items: flex-end;

  .ux-option-item {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 16px;

    .search-label {
      color: $color-text;
      margin-bottom: 8px;
    }

    .btn-text.ux-button {
      padding: 8px 12px;
      border: 1px solid transparent;
    }
  }
}
</style>
